import { useEffect, useRef, useCallback } from 'react';
import { formatNumberDisplay } from '@/utils/bigUtils';
import { useSelectedMarket } from '../store/rootStore';
import { environment } from '../environment.ts';

const DEFAULT_UPDATE_INTERVAL = 30_000;

export function useWindowTitleUpdater() {
  const selectedMarket = useSelectedMarket();
  const intervalRef = useRef<number | null>(null);

  const updateWindowTitle = useCallback(() => {
    if (selectedMarket) {
      const marketInfo = `$${formatNumberDisplay(selectedMarket.markPrice, { minimumFractionDigits: 0, maximumFractionDigits: selectedMarket.quoteDecimals })} | ${selectedMarket.symbol} | `;
      document.title = `${marketInfo}${environment.appName}`;
    } else {
      document.title = environment.appName;
    }
  }, [selectedMarket]);

  useEffect(() => {
    updateWindowTitle();
  }, [updateWindowTitle]);

  useEffect(() => {
    if (selectedMarket) {
      intervalRef.current = window.setInterval(updateWindowTitle, DEFAULT_UPDATE_INTERVAL);
    } else {
      if (intervalRef.current !== null) {
        window.clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }

    return () => {
      if (intervalRef.current !== null) {
        window.clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [selectedMarket, updateWindowTitle]);
}
